import YouTubePlayerFactory from "youtube-player";
import { YouTubePlayer } from "youtube-player/dist/types";
import VimeoPlayer from "@vimeo/player";

const youTubeRegex = new RegExp("^(https?://)?(www.)?(youtube.com|youtu.be)/.+$");

const vimeoRegex = new RegExp("^(https?://)?(www.)?(vimeo.com|player.vimeo.com)/.+$");

const isYouTubeVideo = (url: string) => url.match(youTubeRegex) ?? false;

const isVimeoVideo = (url: string) => url.match(vimeoRegex) ?? false;

export const getPlayer = (iframe: HTMLIFrameElement) => {
  if (isYouTubeVideo(iframe.src)) {
    return YouTubePlayerFactory(iframe);
  }

  if (isVimeoVideo(iframe.src)) {
    return new VimeoPlayer(iframe);
  }

  console.warn("Autoplay is only supported on YouTube and Vimeo videos");
};

export const isYouTubePlayer = (
  player: YouTubePlayer | VimeoPlayer
): player is YouTubePlayer => {
  return (player as YouTubePlayer).playVideo !== undefined;
};

export const isVimeoPlayer = (
  player: YouTubePlayer | VimeoPlayer
): player is VimeoPlayer => {
  return (player as VimeoPlayer).play !== undefined;
};
